import React from "react";
import "./RefundDetailsCard.css";

const RefundDetailsCard = ({ refund }) => {

    if (!refund) return null;

    const {
        finalRefundAmount = 0,
        shippingDeduction = 0,
        gatewayFeeDeducted = 0,
        gatewayTaxDeducted = 0,
        itemAmount = 0,

        refundStatus = "unknown",
        refundType,
        reason,

        processedAt,
        processedBy,

        gatewayRefundId,
        gatewayPaymentId,
        gatewayResponse,

        adminRemark,

        shippingRefundType,   // ✅ IMPORTANT ADDED

        orderItem = {},
    } = refund;

    const status =
        refundStatus?.toLowerCase();

    const isRequested =
        ["requested", "pending"].includes(status);

    const isProcessed =
        ["processed", "success"].includes(status);

    const isFailed =
        ["failed", "cancelled"].includes(status);

    const formatDate = (dateStr) =>
        dateStr
            ? new Date(dateStr).toLocaleString(
                "en-IN",
                {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                }
            )
            : "-";

    const getStatusMeta = (status) => {

        switch (status?.toLowerCase()) {

            case "success":
            case "processed":
                return {
                    color: "#22c55e",
                    label: "Processed",
                };

            case "pending":
                return {
                    color: "#f59e0b",
                    label: "Pending",
                };

            case "failed":
                return {
                    color: "#ef4444",
                    label: "Failed",
                };

            case "cancelled":
                return {
                    color: "#6b7280",
                    label: "Cancelled",
                };

            default:
                return {
                    color: "#374151",
                    label: status || "Unknown",
                };
        }
    };

    const statusMeta =
        getStatusMeta(refundStatus);

    const buildRows = (rows) =>
        rows
            .filter((row) => row.show !== false)
            .map((row, index) => (
                <div
                    className={`refund-row ${row.type || ""}`}
                    key={index}
                >
                    <span>{row.label}</span>
                    <strong>{row.value}</strong>
                </div>
            ));

    // ==========================================
    // CALCULATIONS
    // ==========================================

    const parsedItemAmount =
        Number(itemAmount || 0);

    const parsedShippingDeduction =
        Number(shippingDeduction || 0);

    const parsedGatewayFee =
        Number(gatewayFeeDeducted || 0);

    const parsedGatewayTax =
        Number(gatewayTaxDeducted || 0);

    const parsedRefundAmount =
        Number(finalRefundAmount || 0);

    const totalDeductions =
        parsedShippingDeduction +
        parsedGatewayFee;

    // ==========================================
    // SHIPPING STATE (FIXED)
    // ==========================================

    // const isShippingDeduction =
    //     shippingRefundType === "deduction";

    // // const isShippingRefund =
    // //     shippingRefundType === "refund";

    // const shippingRefundAmount =
    //     Number(refund.shippingRefund || refund.shippingRefundAmount || 0);

    // const isShippingRefund =
    //     shippingRefundType === "refund" && shippingRefundAmount > 0;

    // const isShippingNone =
    //     shippingRefundType === "none" || !shippingRefundType;

    // const shippingAmount =
    //     refund?.orderItem?.order?.shippingCharge ||
    //     250;

    const round2 = (value) => Number(Number(value || 0).toFixed(2));

    const derivedShippingRefund = round2(
        Math.max(
            parsedRefundAmount +
            parsedGatewayFee +
            parsedShippingDeduction -
            parsedItemAmount,
            0
        )
    );

    const isShippingDeduction = parsedShippingDeduction > 0;

    const isShippingRefund = derivedShippingRefund > 0;

    const isShippingNone = !isShippingDeduction && !isShippingRefund;

    return (

        <div className="refund-card">

            {/* HEADER */}
            <div className="refund-header">

                <div>
                    <h2>Refund Details</h2>

                    <p className="refund-subtitle">
                        Complete refund settlement breakdown
                    </p>
                </div>

                <span
                    className="status-badge"
                    style={{
                        backgroundColor:
                            statusMeta.color,
                    }}
                >
                    {statusMeta.label}
                </span>
            </div>

            {/* PENDING INFO */}
            {isRequested && (
                <div className="refund-info-banner">
                    Your refund request has been initiated
                    and is currently under processing.
                </div>
            )}

            <div className="refund-grid">

                {/* PRICE BREAKDOWN */}
                <div className="grid-card">

                    <div className="section-title">
                        Refund Breakdown
                    </div>

                    {buildRows([

                        {
                            label: "Item Amount",
                            value:
                                `₹${parsedItemAmount.toFixed(2)}`,
                        },

                        // {
                        //     label: isShippingDeduction
                        //         ? "Shipping Deduction"
                        //         : isShippingRefund
                        //             ? "Shipping Refund"
                        //             : "Shipping",

                        //     value: isShippingDeduction
                        //         ? `- ₹${parsedShippingDeduction.toFixed(2)}`
                        //         : isShippingRefund
                        //             ? `+ ₹${shippingRefundAmount.toFixed(2)}`
                        //             : `₹0.00`,

                        //     show: true,

                        //     type: isShippingDeduction
                        //         ? "negative"
                        //         : isShippingRefund
                        //             ? "positive"
                        //             : "",
                        // },

                        {
                            label: isShippingDeduction
                                ? "Shipping Deduction"
                                : "Shipping Refund",

                            value: isShippingDeduction
                                ? `- ₹${parsedShippingDeduction.toFixed(2)}`
                                : `+ ₹${derivedShippingRefund.toFixed(2)}`,

                            show: isShippingDeduction || isShippingRefund,

                            type: isShippingDeduction
                                ? "negative"
                                : "positive",
                        },

                        {
                            label: "Gateway Fee(Including GST-18%)",
                            value:
                                `- ₹${parsedGatewayFee.toFixed(2)}`,
                            show:
                                parsedGatewayFee > 0,
                            type: "negative",
                        },

                        {
                            label: "Total Deductions",
                            value:
                                `- ₹${totalDeductions.toFixed(2)}`,
                            show:
                                totalDeductions > 0,
                            type: "negative",
                        },

                        {
                            label: isRequested
                                ? "Expected Refund"
                                : isFailed
                                    ? "Refund Attempted"
                                    : "Final Refund",
                            value:
                                `₹${parsedRefundAmount.toFixed(2)}`,
                            type: "total",
                        },

                    ])}

                    {/* NOTES */}
                    <div className="refund-notes-wrapper">

                        {isShippingDeduction && (
                            <div className="refund-note warning">
                                Shipping charges were deducted because free shipping condition was removed.
                            </div>
                        )}

                        {isShippingRefund && (
                            <div className="refund-note success">
                                Shipping has been refunded because this was last item cancellation / eligible refund case.
                            </div>
                        )}

                        {parsedGatewayFee > 0 && (
                            <div className="refund-note danger">
                                Payment gateway transaction fees are non-refundable once payment is successfully captured.
                            </div>
                        )}

                    </div>
                </div>

                {/* REFUND INFO */}
                <div className="grid-card">

                    <div className="section-title">
                        Refund Information
                    </div>

                    {buildRows([

                        { label: "Refund Status", value: statusMeta.label },

                        { label: "Refund Type", value: refundType || "-", show: !!refundType },

                        { label: "Reason", value: reason || "-", show: !!reason },

                        { label: "Processed By", value: processedBy || "-", show: !!processedBy },

                        { label: "Processed On", value: formatDate(processedAt), show: !!processedAt },

                        { label: "Admin Remark", value: adminRemark || "-", show: !!adminRemark },

                    ])}
                </div>

                {/* GATEWAY INFO */}
                {isProcessed && (

                    <div className="grid-card">

                        <div className="section-title">
                            Payment Gateway Details
                        </div>

                        {buildRows([

                            { label: "Payment ID", value: gatewayPaymentId || "-" },

                            { label: "Refund ID", value: gatewayRefundId || "-" },

                            { label: "Gateway Status", value: gatewayResponse?.status || "-" },

                            {
                                label: "Gateway Refund Amount",
                                value: gatewayResponse?.amount
                                    ? `₹${(gatewayResponse.amount / 100).toFixed(2)}`
                                    : "-",
                            },

                            { label: "Gateway Entity", value: gatewayResponse?.entity || "-" },

                        ])}
                    </div>
                )}

            </div>
        </div>
    );
};

export default RefundDetailsCard;